import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Tabs from 'components/ui/Tabs';
import { BorderControlRequirementItem } from './BorderControlRequirementItem';
import { BordercontrolRequirementsTabs } from './BorderControlRequirementsTabs';

const OUTBOUND_KEY = 'Outbound';
const INBOUND_KEY = 'Inbound';

export const BorderControlRequirementResults = ({ data, isReturnJourney, from, to, allStations }) => {
  const defaultTab = 'Outbound';
  const [selectedTab, setSelectedTab] = useState(defaultTab);
  if (!data) return null;

  return isReturnJourney ? (
    <>
      <Tabs
        selectedValue={selectedTab}
        onClick={setSelectedTab}
        tabs={[
          {
            value: OUTBOUND_KEY,
            label: <BordercontrolRequirementsTabs from={from} to={to} allStations={allStations} outbound={true} />
          },
          {
            value: INBOUND_KEY,
            label: <BordercontrolRequirementsTabs from={from} to={to} allStations={allStations} outbound={false} />
          }
        ]}
      />
      {selectedTab === OUTBOUND_KEY && (
        <>
          <BorderControlRequirementItem
            title={data.outbound.ees.title}
            content={data.outbound.ees.content}
            expendable={data.outbound.ees.expendable}
            type="EES"
            dataCy="outbound-ees"
          />
          <BorderControlRequirementItem
            title={data.outbound.visaOrTravelAuth.title}
            content={data.outbound.visaOrTravelAuth.content}
            expendable={data.outbound.visaOrTravelAuth.expendable}
            dataCy="outbound-visa"
          />
        </>
      )}
      {selectedTab === INBOUND_KEY && (
        <>
          <BorderControlRequirementItem
            title={data.inbound.ees.title}
            content={data.inbound.ees.content}
            expendable={data.inbound.ees.expendable}
            type="EES"
            dataCy="inbound-ees"
          />
          <BorderControlRequirementItem
            title={data.inbound.visaOrTravelAuth.title}
            content={data.inbound.visaOrTravelAuth.content}
            expendable={data.inbound.visaOrTravelAuth.expendable}
            dataCy="inbound-visa"
          />
        </>
      )}
    </>
  ) : (
    <>
      <BorderControlRequirementItem
        title={data.outbound.ees.title}
        content={data.outbound.ees.content}
        expendable={data.outbound.ees.expendable}
        type="EES"
        dataCy="outbound-ees"
      />
      <BorderControlRequirementItem
        title={data.outbound.visaOrTravelAuth.title}
        content={data.outbound.visaOrTravelAuth.content}
        expendable={data.outbound.visaOrTravelAuth.expendable}
        dataCy="outbound-visa"
      />
    </>
  );
};

BorderControlRequirementResults.propTypes = {
  data: PropTypes.object,
  isReturnJourney: PropTypes.bool,
  from: PropTypes.string,
  to: PropTypes.string,
  allStations: PropTypes.array
};
